import './src/styles/global.css';

// prevent fa icons to display full size on page load
import "@fortawesome/fontawesome-svg-core/styles.css"
import { config } from "@fortawesome/fontawesome-svg-core";
config.autoAddCss = false;